'use strict';

import execute_on from "../../../../libs/execute-on";
import {attachFroalaEditor} from "../../../../plugins/froala-editor";

execute_on('admin.cms.page.edit', function () {
    attachFroalaEditor();
});
